import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'cv-ci-public-record-single-field',
	templateUrl: './ci-public-record-single-field.component.html'
})
export class CiPublicRecordSingleFieldComponent implements OnInit {

	@Input() labelPublicRecord: any;
	@Input() dataPublicRecord: any;

	@Output() copiedEvent = new EventEmitter<any>();

	ngOnInit(): void {
		return;
	}

	copyToClipboard() {
		if (this.dataPublicRecord) {
			navigator.clipboard.writeText(this.dataPublicRecord);
			this.copiedEvent.emit();
		}
	}

}
